/* eslint-disable no-console */
import { Auth } from 'aws-amplify';
import axios from 'axios';


export const axiosInstance = axios.create({
  headers: {
    accept: '*/*',
    'Content-type': 'Application/json',
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
});

// Config request headers with API TOKEN
axiosInstance.interceptors.request.use((config) => {
  // Define api Token
  const token = localStorage
    .getItem('apiToken')
    ?.replace(/^["'](.+(?=["']$))["']$/, '$1');

  // Define authenticated routes
  const isRestApiRoute =
    config.url.includes(process.env.NX_REST_API) ||
    config.url.includes('http://127.0.0.1:9090') ||
    config.url.includes('http://127.0.0.1:8080') ||
    config.url.includes('http://15.188.221.254:8080') ||
    (config.url.includes('http://localhost:9090') &&
      !config.url.includes(`/authenticate`));

  // Send token on authenticated routes
  if (isRestApiRoute) {
    const newConfig = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: token ? `Bearer ${token}` : null,
        // Authorization: accessToken ? ${accessToken} : '',
      },
    };

    return newConfig;
  }

  return config;
});

let isRefreshing = false;


const logout = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('apiToken');
  localStorage.removeItem('expired');
  Auth.signOut();
}

axiosInstance.interceptors.response.use(
  (response) => response,

  async (error) => {

    // Intercept token expiration error
    // @TODO : add toast without provider
    if (error?.response?.data.status === 401 &&
      (error.response.data.message === 'Token expiré'
        || error.response.data.message === 'Token falsifié'
        || error.response.data.message === 'Token with invalid user'
        || error.response.data.message === 'Token non validé')) {
      logout();
      localStorage.setItem('expired', 'true');
    }
    const originalRequest = error.config;
    if (!isRefreshing) {
      isRefreshing = true;
      if (error?.response?.status === 401 &&
        error.response.data.message === 'Unauthorized') {
        try {
          const accessToken = Auth.currentSession()
            .then((data) => console.log(data))
            .catch((err) => console.log(err));
          //console.log({ accessToken });
          return axiosInstance(originalRequest);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn(e);
        }
      }


    }
    isRefreshing = false;
    return Promise.reject(error);
  }
);

export const get = ({ url, options = {} }) =>
  axiosInstance.get(url, {
    ...options,
    headers: {
      ...options?.headers,
    },
  });

export const getPdf = ({ url, options = {} }) =>
  axiosInstance.get(url, {
    ...options,
    responseType: 'blob',
    headers: {
      ...options?.headers,
      Accept: 'application/pdf',
    },
  });

export const post = ({ url, data = {}, options = {} }) =>
  axiosInstance.post(url, data, {
    ...options,
    headers: {
      ...options?.headers,
    },
  });

export const put = ({ url, data = {}, options = {} }) =>
  axiosInstance.put(url, data, {
    ...options,
    headers: {
      ...options?.headers,
    },
  });

export const del = ({ url, data = {} }) => axios.delete(url, data);

export const postFiles = ({ url, data, options = {} }) => {
  const formData = new FormData();
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < data.length; i++) {
    formData.append('files', data[i]);
  }
  return axiosInstance.post(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
};

export const postMultipart = ({ url, formData, options = {} }) => {
  return axiosInstance.post(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
}

export const putFiles = ({ url, data, options = {} }) => {
  const formData = new FormData();
  formData.append('cover_picture', data);
  return axiosInstance.put(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
};

export const putFilesProfile = ({ url, data, options = {} }) => {
  const formData = new FormData();
  formData.append('profile_picture', data);
  return axiosInstance.put(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
};

export const postFileAchievement = ({ url, data, options = {} }) => {
  const formData = new FormData();
  formData.append('attachment', data.attachment);
  formData.append('label', data.label);
  formData.append('type', data.type);
  formData.append('path', data.path);
  return axiosInstance.post(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
};

export const postContractV2 = ({ url, data, options = {} }) => {
  const formData = new FormData();
  const { attachment, ...infos } = data;
  const json = JSON.stringify(infos);
  const blob = new Blob([json], {
    type: 'application/json',
  });
  formData.append('file', attachment);
  formData.append('data', blob);
  return axiosInstance.post(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data ; boundary=AaB03x',
      ...options?.headers,
    },
  });
};

export const postVerifProfilStudent = ({ url, data, options = {} }) => {
  const formData = new FormData();
  formData.append('file', data.attachment);
  formData.append('type_id', data.type);
  formData.append('id_number', data.numberIdentity);
  return axiosInstance.post(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
};

export const postFileAffiliation = ({ url, data, options = {} }) => {
  const formData = new FormData();

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < data?.files?.length; i++) {
    formData.append('files', data?.files[i]);
  }

  formData.append('files', data?.files.join());

  formData.append('params', data?.params.join());

  return axiosInstance.post(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
};

export const postContract = ({ url, data, options = {} }) => {
  const formData = new FormData();
  formData.append('file', data?.file);
  return axiosInstance.post(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
};

export const getFileURLPDF = (url, setURL) => {
  axios(url, {
    method: 'GET',
    responseType: 'blob', // Force to receive data in a Blob Format
  })
    .then((response) => {
      // Create a Blob from the PDF Stream
      const file = new Blob([response.data], { type: 'application/pdf' });
      // Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      // Open the URL on new Window
      setURL(fileURL);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log(error);
    });
};

function youtubeParser(url) {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
}

export const postFileMedia = ({ url, data, options = {} }) => {
  const formData = new FormData();
  formData.append('label', data.label);
  formData.append('description', data.description);
  formData.append('type', data.type);
  formData.append('priority', data.priority);
  if (data.type === 'image') {
    formData.append('attachment', data.attachment);
  } else {
    formData.append('path', youtubeParser(data.path));
  }
  return axiosInstance.post(url, formData, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...options?.headers,
    },
  });
};